import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'modal',
    'inlineFirstName',
    'paymentFirstName',
    'inlineLastName',
    'paymentLastName',
    'inlineEmail',
    'paymentEmail',
    'userCompanyInput',
    'orderCompanyInput',
    'updateEmailForm'
  ]
  static values = {
    refreshInterval: Number
  }

  connect() {
    var $this = this
    // catch edge case where modal may cause class to persist if removed by turbo
    $('body').removeClass('modal-shown')

    if (this.data.get('open-on-connect')) {
      this.openConfirmEmailModal()
    }

    this.copyFirstNameToInline()
    this.copyLastNameToInline()
    this.copyEmailToInline()
    this.scrollToIfNeeded()

    window.feather.replace()

    this.emailVerificationElem = document.getElementById('email_verification')
    this.setupExistingEmailListener()
  }

  setupExistingEmailListener() {
    this.existingEmailObserver = new MutationObserver(this.existingEmailMutated.bind(this))
    this.existingEmailObserver.observe(this.emailVerificationElem, { childList: true, subtree: true })
  }

  existingEmailMutated() {
    const $this = this
    if (this.emailVerificationElem.childNodes.length > 0) {
      let nodes = Array.from(this.emailVerificationElem.childNodes)
      nodes.forEach(node => {
        if (node.classList && node.classList.contains("existing-email")) { $this.openSignInModal(null, true) }
      })
    }
  }

  checkIfLoggedIn() {
    if (this.hasRefreshIntervalValue) {
      setInterval(() => {
        this.showCreateTeamModal()
      }, this.refreshIntervalValue)
    }
  }

  showCreateTeamModal() {
    var tok = this.data.get("confirmation-token")

    $.ajax({
      type: 'GET',
      url: `/check-account-confirmed/?confirmation_token=${tok}`,
      success: function (res) {
        if (res === true) {
          this.refreshIntervalTarget = null
          window.location.reload()
        }
      },
      error: function (err) {

      },
    })
  }

  copyFirstNameToInline() {
    if (this.hasInlineFirstNameTarget && this.hasPaymentFirstNameTarget) {
      this.inlineFirstNameTarget.value = this.paymentFirstNameTarget.value
    }
  }

  copyLastNameToInline() {
    if (this.hasInlineLastNameTarget && this.hasPaymentLastNameTarget) {
      this.inlineLastNameTarget.value = this.paymentLastNameTarget.value
    }
  }

  copyFirstNameToPayment() {
    this.paymentFirstNameTarget.value = this.inlineFirstNameTarget.value
  }

  copyLastNameToPayment() {
    this.paymentLastNameTarget.value = this.inlineLastNameTarget.value
  }

  copyEmailToPayment() {
    if (this.hasInlineEmailTarget && this.hasPaymentEmailTarget) {
      this.paymentEmailTarget.value = this.inlineEmailTarget.value
    }
  }

  copyEmailToInline() {
    if (this.hasInlineEmailTarget && this.hasPaymentEmailTarget) {
      this.inlineEmailTarget.value = this.paymentEmailTarget.value
    }
  }

  scrollToIfNeeded() {
    var scrollTo = this.data.get("scroll-to")
    if (scrollTo == "additional_requests") {
      let el = document.querySelector("#user_order_additional_requests")
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus()
      }
    } else if (scrollTo == "video_software_preference") {
      let el = document.querySelector("#user_order_video_software_preference")
      if (el) {
        // show
        $(".video-preference").removeClass("hidden");
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus()
      }
    }
  }

  copyOrderCompanyNameToUser() {
    if (this.hasUserCompanyInputTarget && this.hasOrderCompanyInputTarget) {
      this.userCompanyInputTarget.value = this.orderCompanyInputTarget.value
    }
  }

  openShareModal(e) {
    e.preventDefault()
    window.dispatchEvent(new CustomEvent("openShareModal"))
  }

  openSignInModal(e, existingEmail=false) {
    if (e) e.preventDefault()
    const customEventDetailData = { email: this.paymentEmailTarget.value, type: "signIn" }
    if (existingEmail) {
      customEventDetailData['message'] = "Looks like you already have an account with us using this email address, please sign in to associate this order with your team."
    }
  }

  openConfirmEmailModal(e) {
    e.preventDefault()

    $(this.modalTarget).addClass('active')
    $('body').addClass('modal-shown')
  }

  closeModal(e) {
    if (
      !$(e.target).hasClass('modal') &&
      !$(e.target).hasClass('close-modal') &&
      !$(e.target).hasClass('close-modal-btn')
    )
      return

    e.preventDefault()
    this.close()
  }

  close() {
    if (this.modalTarget.classList.contains("active")) {
      $(this.modalTarget).removeClass('active')
      $('body').removeClass('modal-shown')
    }
  }

  submitNewEmail() {
    this.updateEmailFormTarget.requestSubmit()
    $('#order_purchase > div.user-inputs #user_email').val(this.paymentEmailTarget.value);
    document.getElementById('user_cardholder_name').innerHTML = this.paymentEmailTarget.value.split("@")[0];
  }

  escClose(event) {
    if (event.key === 'Escape') this.close()
  }
}
